import { render, staticRenderFns } from "./FormatQuestionnairePropertyEditor.vue?vue&type=template&id=46c4d8aa&scoped=true&"
import script from "./FormatQuestionnairePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatQuestionnairePropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatQuestionnairePropertyEditor.vue?vue&type=style&index=0&id=46c4d8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c4d8aa",
  null
  
)

export default component.exports